<template>
  <div class="field has-addons">
    <div class="control is-expanded">
      <input
        type="search"
        class="input"
        v-model="search"
        placeholder="eg. name, mobile, email"
        @keyup.enter="onSearch"
      />
    </div>
    <div class="control">
      <button class="button is-primary" @click="onSearch" :disabled="search.length === 0">Search</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: ""
    };
  },
  computed: {
    loading() {
      let component = this;
      return component.$store.getters["user/loading"];
    }
  },
  methods: {
    onSearch() {
      let component = this;
      component.isLoading = true;
      component.$store.commit("user/search", component.search);
      component.$store.commit("user/page", 1);
      component.$store
        .dispatch("user/index")
        .then(() => {
          component.isLoading = false;
        })
        .catch(error => {
          component.isLoading = false;
          console.log(error);
        });
    }
  },
  watch: {
    search() {
      let component = this;
      if (component.search.length === 0) {
        component.onSearch();
      }
    },
    isLoading() {
      let component = this;
      component.$emit("loading", isLoading);
    }
  }
};
</script>